import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=7e7b0b1e&"
import script from "./SidebarMenu.vue?vue&type=script&lang=js&"
export * from "./SidebarMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports